// Rules for VALIDATION_CONSTRAINTS.md section 6 — end event content.
// Cardinality (6.1) is covered by 3.2 and intentionally skipped here.
import { registerRule } from '../registry';
import { ValidationRule, ValidationIssue } from '../types';
import { labelOf } from '../helpers';

// 6.1: Skipped — end-event cardinality (>=1 incoming, 0 outgoing) is enforced by rule 3.2.

// 6.2: MessageEndEvent requires a non-empty messageName.
const rule_6_2_MessageEndEventName: ValidationRule = {
  id: '6.2',
  description: 'MessageEndEvent requires a non-empty messageName',
  scope: 'process',
  run: (_ctx, process) => {
    if (!process) return [];
    const issues: ValidationIssue[] = [];
    for (const n of process.nodes) {
      if (n.type !== 'MessageEndEvent') continue;
      const name = (n.data?.messageName ?? '').toString().trim();
      if (!name) {
        issues.push({
          severity: 'error',
          rule: '6.2',
          message: `${labelOf(n)} requires a non-empty messageName.`,
          nodeIds: [n.id],
        });
      }
    }
    return issues;
  },
};
registerRule(rule_6_2_MessageEndEventName);

// 6.3: SignalEndEvent requires a non-empty signalName.
const rule_6_3_SignalEndEventName: ValidationRule = {
  id: '6.3',
  description: 'SignalEndEvent requires a non-empty signalName',
  scope: 'process',
  run: (_ctx, process) => {
    if (!process) return [];
    const issues: ValidationIssue[] = [];
    for (const n of process.nodes) {
      if (n.type !== 'SignalEndEvent') continue;
      const name = (n.data?.signalName ?? '').toString().trim();
      if (!name) {
        issues.push({
          severity: 'error',
          rule: '6.3',
          message: `${labelOf(n)} requires a non-empty signalName.`,
          nodeIds: [n.id],
        });
      }
    }
    return issues;
  },
};
registerRule(rule_6_3_SignalEndEventName);

// 6.4: ErrorEndEvent requires exceptionType OR errorMessage (populated).
const rule_6_4_ErrorEndEventPayload: ValidationRule = {
  id: '6.4',
  description: 'ErrorEndEvent requires exceptionType or errorMessage',
  scope: 'process',
  run: (_ctx, process) => {
    if (!process) return [];
    const issues: ValidationIssue[] = [];
    for (const n of process.nodes) {
      if (n.type !== 'ErrorEndEvent') continue;
      const exceptionType = ((n.data as any)?.exceptionType ?? '').toString().trim();
      const errorMessage = (n.data?.errorMessage ?? '').toString().trim();
      if (!exceptionType && !errorMessage) {
        issues.push({
          severity: 'error',
          rule: '6.4',
          message: `${labelOf(n)} requires an exceptionType or errorMessage.`,
          nodeIds: [n.id],
        });
      }
    }
    return issues;
  },
};
registerRule(rule_6_4_ErrorEndEventPayload);

// 6.5: EscalationEndEvent should have an escalationName.
//      The field is not declared in WorkflowNodeData — emit a warning if missing
//      rather than an error, since escalation wiring is not yet fully modeled.
const rule_6_5_EscalationEndEventName: ValidationRule = {
  id: '6.5',
  description: 'EscalationEndEvent should have an escalationName',
  scope: 'process',
  run: (_ctx, process) => {
    if (!process) return [];
    const issues: ValidationIssue[] = [];
    for (const n of process.nodes) {
      if (n.type !== 'EscalationEndEvent') continue;
      const name = ((n.data as any)?.escalationName ?? '').toString().trim();
      if (!name) {
        issues.push({
          severity: 'warning',
          rule: '6.5',
          message: `${labelOf(n)} has no escalationName — escalation handling is not wired up.`,
          nodeIds: [n.id],
        });
      }
    }
    return issues;
  },
};
registerRule(rule_6_5_EscalationEndEventName);

// 6.6: TerminateEndEvent requires a non-empty reason.
const rule_6_6_TerminateEndEventReason: ValidationRule = {
  id: '6.6',
  description: 'TerminateEndEvent requires a non-empty reason',
  scope: 'process',
  run: (_ctx, process) => {
    if (!process) return [];
    const issues: ValidationIssue[] = [];
    for (const n of process.nodes) {
      if (n.type !== 'TerminateEndEvent') continue;
      const reason = (n.data?.reason ?? '').toString().trim();
      if (!reason) {
        issues.push({
          severity: 'error',
          rule: '6.6',
          message: `${labelOf(n)} requires a non-empty reason.`,
          nodeIds: [n.id],
        });
      }
    }
    return issues;
  },
};
registerRule(rule_6_6_TerminateEndEventReason);
